export default function AnalyticsPanel({
  visitorsCount,
  pageViewsCount,
  topServices,
  topPages,
  recentPages,
}) {
  return (
    <section className="rounded-[30px] border border-white/10 bg-[#101014] p-6 shadow-2xl shadow-black/30 backdrop-blur-xl">
      {/* Header */}
      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-zinc-500">
            Site Analytics
          </p>

          <h2 className="mt-2 text-3xl font-black text-white">
            Website Performance
          </h2>
        </div>

        <div className="flex gap-4">
          <div className="rounded-2xl border border-white/10 bg-white/5 px-5 py-4">
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500">
              Visitors
            </p>

            <p className="mt-2 text-3xl font-black text-[#F28C18]">
              {visitorsCount}
            </p>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 px-5 py-4">
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500">
              Page Views
            </p>

            <p className="mt-2 text-3xl font-black text-white">
              {pageViewsCount}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="grid gap-6 xl:grid-cols-[1.5fr_1fr]">
        {/* Left */}
        <div className="space-y-6">
          {/* Services */}
          <div className="rounded-[24px] border border-white/10 bg-[#08080A] p-6">
            <h3 className="mb-5 text-xl font-black text-white">
              Top Services
            </h3>

            <div className="space-y-4">
              {topServices.length ? (
                topServices.map((service) => (
                  <div key={service.name}>
                    <div className="mb-2 flex justify-between text-sm">
                      <span className="text-zinc-300">{service.name}</span>

                      <span className="font-black text-[#F28C18]">
                        {service.count}
                      </span>
                    </div>

                    <div className="h-2 overflow-hidden rounded-full bg-white/10">
                      <div
                        className="h-full rounded-full bg-[#F28C18]"
                        style={{
                          width: `${Math.min(service.count * 10, 100)}%`,
                        }}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-zinc-500">No data available.</p>
              )}
            </div>
          </div>

          {/* Recent Activity */}
          <div className="rounded-[24px] border border-white/10 bg-[#08080A] p-6">
            <h3 className="mb-5 text-xl font-black text-white">
              Recent Activity
            </h3>

            <div className="space-y-3">
              {recentPages.length ? (
                recentPages.map((item, index) => (
                  <div
                    key={`${item.page}-${index}`}
                    className="flex items-center justify-between rounded-2xl border border-white/5 bg-white/5 px-4 py-4 transition hover:border-[#F28C18]/30 hover:bg-white/10"
                  >
                    <span className="font-medium text-zinc-200">
                      {item.page}
                    </span>

                    <span className="text-xs text-zinc-500">
                      {item.date}
                    </span>
                  </div>
                ))
              ) : (
                <p className="text-zinc-500">No activity yet.</p>
              )}
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="space-y-6">
          <div className="rounded-[24px] border border-white/10 bg-[#08080A] p-6">
            <h3 className="mb-5 text-xl font-black text-white">
              Top Pages
            </h3>

            <div className="space-y-3">
              {topPages.length ? (
                topPages.map((page) => (
                  <div
                    key={page.name}
                    className="flex items-center justify-between rounded-2xl border border-white/5 bg-white/5 px-4 py-4"
                  >
                    <span className="text-zinc-200">
                      {page.name}
                    </span>

                    <span className="rounded-full bg-[#F28C18]/10 px-3 py-1 text-sm font-black text-[#F28C18]">
                      {page.count}
                    </span>
                  </div>
                ))
              ) : (
                <p className="text-zinc-500">No page data.</p>
              )}
            </div>
          </div>

          {/* Overview Card */}
          <div className="rounded-[24px] border border-[#F28C18]/20 bg-gradient-to-br from-[#F28C18]/10 to-transparent p-6">
            <p className="text-sm uppercase tracking-[0.3em] text-zinc-400">
              Overview
            </p>

            <h3 className="mt-3 text-4xl font-black text-white">
              {visitorsCount}
            </h3>

            <p className="mt-2 text-zinc-400">
              Total visitors recorded across the website.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}